import React from 'react';

import Button from 'components/Button';
import './styles.css';

const Buttons = ({triggerSubmit, submitting, onClose, disabled}) => (
  <div className="Buttons">
    <Button onClick={onClose} transparent white className="Buttons__cancel">
      Cancel
    </Button>
    <Button
      onClick={triggerSubmit}
      className="Buttons__submit"
      blue={!submitting}
      isLoading={submitting}
      disabled={submitting || disabled}>
      Create
    </Button>
  </div>
);

export default Buttons;
